import _ from 'lodash'
import { useSelectedFeatureId } from 'map-feature-info'
import { MS_UUID, getMarkerStyle } from 'map-style-utils'
import { Layer, LayerProps } from 'ms-map-gl'
import { useMemo } from 'react'

import { FeatureIdentifyPlugin } from '~map-preview/App/Map/Plugins/FeatureIdentifyPlugin'
import { HoverPlugin } from '~map-preview/App/Map/Plugins/HoverPlugin'
import { useLayerFilter } from '~map-preview/hooks/useLayerFilter'
import { getLayerId } from '~map-preview/utils/getLayerId'

export const PointLayer = () => {
  const selectedFeatureId = useSelectedFeatureId()
  const layerFilter = useLayerFilter()

  const { symbol } = useMemo(
    () =>
      getMarkerStyle({
        selected: selectedFeatureId || '',
        property: MS_UUID
      }),
    [selectedFeatureId]
  )

  return (
    <>
      <Layer
        {...(symbol as LayerProps)}
        {...(layerFilter as object)}
      />

      <HoverPlugin
        source='mapstack-points'
        layer={_.get(symbol, 'id', '')}
      />

      <FeatureIdentifyPlugin layer={getLayerId(symbol)} />
    </>
  )
}
